import { useEffect, useMemo } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { collection, query, where } from "firebase/firestore";
import { getDate } from "@poseidon/firebase/timestamp";

const mapSchedule = (doc) => {
  let data = doc.data();
  return {
    id: doc.id,
    ...data,
    startDate: getDate(data.startDate),
  };
};

export const useSchedules = (agreementId) => {
  const [value, loading, error] = useCollection(
    query(
      collection(db, "paymentSchedules"),
      where("agreementId", "==", agreementId)
    )
  );
  useEffect(() => {
    if (error) {
      console.error("Error reading schedules", error);
    }
  }, [error]);
  const schedules = useMemo(() => {
    if (!value) {
      return [];
    }
    return value.docs
      .map(mapSchedule)
      .sort((a, b) => a.startDate - b.startDate);
  }, [value]);
  return { schedules, loading, error };
};
